export default __webpack_public_path__ + "static/media/grafema_SET_15.6c88e01a.jpg";